module.exports = __webpack_public_path__ + "img/powerplay.c7505b7a.png";